import React from 'react';

export const RegionContext = React.createContext({});